import HomePage from '../pages/HomePage';
import AboutPage from '../pages/AboutPage';
import ContactPage from '../pages/ContactPage';
import ArtistPage from '../pages/ArtistPage';
import ArtistDetailPage from '../pages/ArtistDetailPage';
import FAQPage from '../pages/FAQPage';
import VersionHistoryPage from '../pages/VersionHistoryPage';
import CardCustomPage from '../pages/CardCustomPage';
import WalletPage from '../pages/WalletPage';
import NotificationsPage from '../pages/NotificationsPage';
import AccountPage from '../pages/AccountPage';
import CustomizationsPage from '../pages/CustomizationsPage';
import PacksBuyPage from '../pages/packs/BuyPacksPage';
import UserPacksPage from '../pages/packs/UserPacksPage';
import CardsUserPage from '../pages/cards/UserCardsPage';
import SellCardsPage from '../pages/cards/SellCardsPage';
import RegisterPage from '../pages/RegisterPage';
import LoginPage from '../pages/LoginPage';
import ForgotPasswordPage from '../pages/ForgotPasswordPage';
import LogoutPage from '../pages/LogoutPage';
import SeriesManagementPage from '../pages/series/SeriesManagementPage';
import BulkCardsPage from '../pages/cards/BulkCardsPage';
import SeriesDetailsPage from '../pages/series/SeriesDetailPage';
import AllSeriesPage from '../pages/series/AllSeriesPage';
import CardDetailsPage from '../pages/cards/CardDetailsPage';
import TeamBuilderPage from '../pages/team/TeamBuilderPage';
import ViewTeams from '../pages/team/ViewTeamsPage';
import ViewGames from '../pages/games/ViewGamesPage';
import CreateGame from '../pages/games/CreateGamePage';
import PlayGame from '../pages/games/PlayGamePage';
import SummaryGame from '../pages/games/GameSummaryPage';
import AdminRollPage from '../pages/admin/AdminDiceRollPage';
import AdminUsersPage from '../pages/admin/AdminUsersPage';
import AdminCustomCardPage from '../pages/admin/AdminCustomCardPage';
import LeaderboardPage from '../pages/leaderboard/LeaderboardPage';
import LeaderboardMonthlyPage from '../pages/leaderboard/LeaderboardMonthlyPage';
import EloLeaderboardPage from '../pages/leaderboard/EloLeaderboardPage';
import CreateCompTeamPage from '../pages/team/CreateCompTeamPage';
import ViewCompTeamsPage from '../pages/team/ViewCompTeamsPage';
import ViewRewardsPage from '../pages/rewards/ViewRewardsPage';
import CreateRewardsPage from '../pages/rewards/CreateRewardsPage';
import CreateCampaignPage from '../pages/campaigns/CreateCampaignPage';
import ViewCampaignsPage from '../pages/campaigns/ViewCampaignsPage';
import CreateCampaignContestPage from '../pages/campaigns/CreateCampaignContestPage';
import CampaignContestDetailPage from '../pages/campaigns/CampaignContestDetailPage';
import EditCampaignContestPage from '../pages/campaigns/EditCampaignContestPage';
import CampaignDetailPage from '../pages/campaigns/CampaignDetailPage';
import PlayCampaignContestPage from '../pages/campaigns/PlayCampaignContestPage';
import MyBindersPage from '../pages/binders/MyBindersPage';
import BinderPage from '../pages/binders/BinderPage';
import AdminBadgesPage from '../pages/admin/AdminBadgesPage';
import AdminVariationsPage from '../pages/admin/AdminVariationsPage';
import AdminSeriesVariationsPage from '../pages/admin/AdminSeriesVariationsPage';
import TournamentPage from '../pages/tournament/TournamentPage';
import PlayoffPage from '../pages/playoff/PlayoffPage';
import TournamentResultsPage from '../pages/tournament/TournamentResultsPage';
import AuthCallbackPage from '../pages/AuthCallbackPage';
import ChooseUsernamePage from '../pages/ChooseUsernamePage';
import PrivacyPage from '../pages/PrivacyPage';
import TermsPage from '../pages/TermsPage';
import PublicProfilePage from '../pages/profile/PublicProfilePage';
import MessagesPage from '../pages/MessagesPage';
import TournamentPointsPage from '../pages/leaderboard/TournamentPointsPage';
import PlayoffPointsPage from '../pages/leaderboard/PlayoffPointsPage';

const routes = [
    { path: '/', component: HomePage },
    { path: '/about', component: AboutPage },
    { path: '/contact', component: ContactPage },
    { path: '/artists', component: ArtistPage },
    { path: '/artists/:artistID', component: ArtistDetailPage },
    { path: '/faq', component: FAQPage },
    { path: '/privacy', component: PrivacyPage },
    { path: '/terms', component: TermsPage },
    { path: '/version-history', component: VersionHistoryPage },
    { path: '/cardCustom', component: CardCustomPage, private: true },
    { path: '/wallet', component: WalletPage, private: true },
    { path: '/notifications', component: NotificationsPage, private: true },
    { path: '/account', component: AccountPage, private: true },
    { path: '/customizations', component: CustomizationsPage, private: true },
    { path: '/login', component: LoginPage },
    { path: '/auth/callback', component: AuthCallbackPage },
    { path: '/auth/choose-username', component: ChooseUsernamePage },
    { path: '/forgot-password', component: ForgotPasswordPage },
    { path: '/logout', component: LogoutPage },
    { path: '/leaderboard', component: LeaderboardPage },
    { path: '/leaderboard/monthly', component: LeaderboardMonthlyPage },
    { path: '/leaderboard/monthly/:monthYear', component: LeaderboardMonthlyPage },
    { path: '/leaderboard/elo', component: EloLeaderboardPage },
    { path: '/leaderboard/tournament-points', component: TournamentPointsPage },
    { path: '/leaderboard/playoff-points', component: PlayoffPointsPage },
    { path: '/register', component: RegisterPage },
    { path: '/packs/buy', component: PacksBuyPage, private: true },
    { path: '/packs/user', component: UserPacksPage, private: true },
    { path: '/cards/user', component: CardsUserPage, private: true },
    { path: '/cards/sell', component: SellCardsPage, private: true },
    { path: '/team/create', component: TeamBuilderPage, private: true },
    { path: '/team/edit', component: TeamBuilderPage, private: true },
    { path: '/team/user', component: ViewTeams, private: true },
    { path: '/games/user', component: ViewGames, private: true },
    { path: '/rewards', component: ViewRewardsPage, admin: true },
    { path: '/rewards/create', component: CreateRewardsPage, admin: true },
    { path: '/team/comp-team', component: CreateCompTeamPage, admin: true },
    { path: '/team/view-comp-teams', component: ViewCompTeamsPage, admin: true },
    { path: '/admin/roll-page', component: AdminRollPage, admin: true },
    { path: '/admin/series-management', component: SeriesManagementPage, admin: true },
    { path: '/admin/cards/bulk', component: BulkCardsPage, admin: true },
    { path: '/admin/cards/custom', component: AdminCustomCardPage, admin: true },
    { path: '/admin/series', component: AllSeriesPage, admin: true },
    { path: '/admin/users', component: AdminUsersPage, admin: true },
    { path: '/admin/badges', component: AdminBadgesPage, admin: true },
    { path: '/admin/variations', component: AdminVariationsPage, admin: true },
    { path: '/admin/series-variations', component: AdminSeriesVariationsPage, admin: true },
    { path: '/admin/series/:seriesID', component: SeriesDetailsPage, admin: true },
    { path: '/campaigns/create', component: CreateCampaignPage, admin: true },
    { path: '/campaigns', component: ViewCampaignsPage },
    { path: '/campaign-contests/create', component: CreateCampaignContestPage, admin: true },
    { path: '/campaign-contests/:campaignContestID/edit', component: EditCampaignContestPage, admin: true },
    { path: '/campaign-contests/:campaignContestID', component: CampaignContestDetailPage },
    { path: '/campaign-contests/:userCampaignContestID/play', component: PlayCampaignContestPage },
    { path: '/campaigns/:campaignID', component: CampaignDetailPage },
    { path: '/cards/inventory/:inventoryID', component: CardDetailsPage, private: true },
    { path: '/cards/:cardID', component: CardDetailsPage },
    { path: '/game/create', component: CreateGame, private: true },
    { path: '/game/create/:campaignContestID', component: CreateGame, private: true },
    { path: '/game/:gameID/play', component: PlayGame, private: true },
    { path: '/game/:gameID/summary', component: SummaryGame, private: true },
    { path: '/tournament', component: TournamentPage },
    { path: '/playoff', component: PlayoffPage, private: true },
    { path: '/tournament/:tournamentID/results', component: TournamentResultsPage },
    { path: '/messages', component: MessagesPage, private: true },
    { path: '/binders', component: MyBindersPage, private: true },
    { path: '/:username/binder/:binderNumber', component: BinderPage },
    { path: '/u/:username', component: PublicProfilePage },
];

export default routes;
